// This file is used for maintain and manage API services
(function () {
  'use strict';
  angular.module('obex').
  factory('tripFields', ['$http', '$q', 'obexConstant', 'authService',
    ($http, $q, obexConstant, authService) => {
      return {
        getTripFields() {
          return authService.getAuthorizationHeader().then(authHeader =>
            $http.get(obexConstant.urlTripField, {
              headers: authHeader,
            }));
        },

        getTripFieldById(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlTripField}/${id}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },

        addTripField(tripField) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlTripField}`;
            const postData = {
              Id: tripField.Id,
              Name: tripField.Name,
              OrganizationId: tripField.OrganizationId,
              Required: tripField.Required,
              AgencyDefinition: tripField.AgencyDefinition,
            };
            return $http.post(url, postData, {
              headers: authHeader,
            });
          });
        },

        addTripFieldOption(tripFieldId, tripFieldOptionList) {
          const promises = _.map(tripFieldOptionList, tripFieldOption => {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlTripFieldOptions}`;
              const postData = {
                Id: tripFieldOptionList.Id,
                Name: tripFieldOption.Name,
                TripFieldId: tripFieldId,
              };
              return $http.post(url, postData, {
                headers: authHeader,
              });
            });
          });
          return $q.all(promises);
        },

        updateTripField(id, tripField) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlTripField}/${id}`;
            const putData = {
              Id: tripField.Id,
              Name: tripField.Name,
              OrganizationId: tripField.OrganizationId,
              Required: tripField.Required,
              AgencyDefinition: tripField.AgencyDefinition,
            };
            return $http.put(url, putData, {
              headers: authHeader,
            });
          });
        },

        updateTripFieldOption(id, tripFieldOptionList) {
          const promises = _.map(tripFieldOptionList, tripFieldOption => {
            return authService.getAuthorizationHeader().then(authHeader => {
              if (!!tripFieldOption.Id) {
                const url = `${obexConstant.urlTripFieldOptions}/${tripFieldOption.Id}`;
                const putData = {
                  Id: tripFieldOption.Id,
                  Name: tripFieldOption.Name,
                  TripFieldId: tripFieldOption.TripFieldId,
                };
                return $http.put(url, putData, {
                  headers: authHeader,
                });
              } else {
                const url = `${obexConstant.urlTripFieldOptions}/`;
                const postData = {
                  Id: tripFieldOption.Id,
                  Name: tripFieldOption.Name,
                  TripFieldId: tripFieldOption.TripFieldId,
                };
                return $http.post(url, postData, {
                  headers: authHeader,
                });
              }
            });
          });
          return $q.all(promises);
        },

        deleteTripField(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlTripField}/${id}`;
            return $http.delete(url, {
              headers: authHeader,
            });
          });
        },

        deleteTripFieldOption(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = obexConstant.urlTripFieldOptions + '/' + id;
            return $http.delete(url, {
              headers: authHeader,
            });
          });
        },
      };
    },
  ]);
})();



// WEBPACK FOOTER //
// ./client/js/services/tripFields.service.js